import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductImportationStatusEnum } from 'src/app/Enums/ProductImportationStatusEnum';
import { ProductImportation } from 'src/app/models/Product/Import/ProductImportation.model';
import { ProductReportSelected } from 'src/app/models/Product/ProductReport.model';
import { AlertMessageService } from 'src/app/services/alert-message/alert-message.service';
import { ProductImportationService } from 'src/app/services/product/importation/product-importation.service';
import { ProductService } from 'src/app/services/product/product.service';

@Component({
  selector: 'app-product-set-taxation-button',
  templateUrl: './product-set-taxation-button.component.html',
  styleUrls: ['./product-set-taxation-button.component.scss']
})
export class ProductSetTaxationButton implements OnInit, OnDestroy {

  @Input() screenName: string = "";
  @Input() getSeleted!:() => ProductReportSelected[];
  @Input() funcNfceEnabled!:  string | null;
  get showNfceConfig(): string | null { return this.funcNfceEnabled || "" }

  constructor(
    private productService:ProductService,
    private alertService: AlertMessageService
 
  ) {
    
  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
   
  }

  openModal() {
    if(!this.showNfceConfig){
      this.alertService.alertWarningMessage("A emissão de NFC-e precisa estar ativada para realizar esta ação!");
      return;
    }
    const items = this.getSeleted();
    this.productService.openSetTaxationDialogAlert(items);

  }

  

}
